var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarWoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 358.658 358.658",
    style: {
      enableBackground: "new 0 0 358.658 358.658"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_45_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M296.309,317.73v40.68H62.349v-40.68c0-14.71,3.36-28.51,9.45-40.41 c6.51-12.73,16.15-23.29,28.15-30.5c0.75-0.45,1.51-0.89,2.28-1.33c1.16-0.64,2.35-1.26,3.56-1.83c0.8-0.38,1.6-0.75,2.42-1.12 c0,0,0,0,0.01,0c2.05-0.89,4.15-1.69,6.31-2.41c1.72-0.57,3.47-1.07,5.25-1.51c0.01,0,0.01,0,0.02,0 c1.48-0.37,2.98-0.69,4.51-0.98c4.59-0.85,9.37-1.29,14.31-1.29c0.01,0,0.01,0,0.02,0l40.69,24l40.69-24 c6.59,0,12.89,0.79,18.84,2.27c7.16,1.77,13.8,4.56,19.85,8.2C281.929,260.77,296.309,287.3,296.309,317.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M296.308,317.734v40.68h-116.98v-98.06l36-21.23l4.69-2.77 c6.59,0,12.89,0.78,18.84,2.27c7.16,1.77,13.8,4.55,19.85,8.2C281.928,260.774,296.308,287.304,296.308,317.734z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    style: {
      fill: "#682234"
    },
    d: "M258.705,358.658V243.063c-6.043-3.641,8.31-6.43,1.156-8.196l-21,71.339h-99.065 l-40-71.339c-7.154,1.766,6.198,4.554,0.156,8.196v115.594L258.705,358.658L258.705,358.658z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_805_",
    style: {
      fill: "#521627"
    },
    d: "M258.861,234.868l-40,71.339h-39.533v52.451h79.377V243.063 C252.662,239.422,266.014,236.634,258.861,234.868z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_806_",
    style: {
      fill: "#C64832"
    },
    d: "M289.469,141.269C289.469,59.796,246.723,0,178.829,0 S68.189,59.796,68.189,141.269c0,21.095-14.08,42.87,8.3,65.903c-3.374,4.791-5.361,10.629-5.361,16.934 c0,16.268,13.188,29.456,29.456,29.456c3.489,0,6.833-0.61,9.939-1.723c19.56,27.308,43.932,37.6,68.307,37.6 s48.747-10.292,68.307-37.601c3.105,1.113,6.451,1.724,9.939,1.724c16.268,0,29.456-13.188,29.456-29.456 c0-6.305-1.988-12.143-5.361-16.934C303.549,184.139,289.469,162.364,289.469,141.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_809_",
    style: {
      fill: "#B2332D"
    },
    d: "M289.469,141.269c0-81.272-42.538-140.968-110.14-141.262V291.94 c24.208-0.402,48.38-12.98,67.807-40.101c3.105,1.113,6.451,1.724,9.939,1.724c16.268,0,29.456-13.188,29.456-29.456 c0-6.305-1.988-12.143-5.361-16.934C303.549,184.139,289.469,162.364,289.469,141.269z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_810_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M211.786,300.44c5.945-7.414,10.232-18.847,10.232-37.107 c0,0-14.458-18.417-14.458-81.376h-26.23h-5.002h-26.23c0,62.959-14.458,81.376-14.458,81.376c0,18.26,4.287,29.693,10.232,37.107 H211.786z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_811_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M211.786,300.44c5.945-7.414,10.232-18.847,10.232-37.107 c0,0-14.458-18.417-14.458-81.376h-26.23h-2.001V300.44H211.786z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_812_",
    style: {
      fill: "#F3DBC4"
    },
    d: "M116.255,80.513c-4.453,33.245,0.539,75.661,6.918,87.439 c9.043,16.694,29.221,38.957,55.657,38.957c26.431,0,46.607-22.262,55.652-38.957c3.915-7.229,7.307-26.002,8.315-47.109 C230.857,120.005,135.767,112.362,116.255,80.513z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_813_",
    style: {
      fill: "#EDCEAE"
    },
    d: "M239.644,120.603c-0.062-0.005-0.117-0.009-0.18-0.014 c-0.257-0.021-0.533-0.044-0.81-0.067c-0.116-0.01-0.225-0.019-0.344-0.029c-0.241-0.02-0.496-0.042-0.75-0.064 c-0.179-0.015-0.353-0.03-0.539-0.047c-0.226-0.02-0.464-0.041-0.699-0.062c-0.232-0.021-0.46-0.041-0.701-0.063 c-0.217-0.02-0.444-0.041-0.668-0.062c-0.272-0.025-0.543-0.05-0.826-0.077c-0.233-0.022-0.474-0.045-0.714-0.068 c-0.287-0.027-0.573-0.055-0.87-0.084c-0.248-0.024-0.503-0.05-0.757-0.075c-0.308-0.031-0.617-0.061-0.935-0.094 c-0.26-0.026-0.526-0.054-0.793-0.081c-0.327-0.034-0.654-0.068-0.99-0.103c-0.275-0.029-0.554-0.059-0.835-0.089 c-0.339-0.036-0.68-0.073-1.028-0.111c-0.29-0.032-0.585-0.064-0.881-0.097c-0.354-0.039-0.709-0.079-1.071-0.12 c-0.309-0.035-0.621-0.071-0.935-0.107c-0.359-0.041-0.721-0.083-1.088-0.126c-0.327-0.038-0.656-0.077-0.988-0.117 c-0.367-0.044-0.738-0.088-1.112-0.134c-0.345-0.042-0.692-0.084-1.043-0.128c-0.373-0.046-0.749-0.093-1.128-0.141 c-0.362-0.046-0.725-0.092-1.093-0.139c-0.376-0.048-0.755-0.097-1.136-0.147c-0.383-0.05-0.767-0.1-1.155-0.152 c-0.377-0.05-0.757-0.101-1.139-0.153c-0.402-0.054-0.805-0.109-1.212-0.165c-0.374-0.052-0.751-0.104-1.128-0.157 c-0.422-0.059-0.845-0.119-1.273-0.18c-0.381-0.054-0.765-0.11-1.149-0.166c-0.431-0.063-0.862-0.125-1.298-0.19 c-0.379-0.056-0.761-0.114-1.143-0.172c-0.456-0.069-0.911-0.137-1.372-0.208c-0.364-0.056-0.732-0.114-1.099-0.171 c-0.48-0.075-0.96-0.15-1.445-0.228c-0.356-0.057-0.716-0.116-1.074-0.174c-0.505-0.082-1.009-0.164-1.517-0.248 c-0.333-0.055-0.669-0.113-1.004-0.169c-0.538-0.091-1.076-0.181-1.618-0.274c-0.31-0.053-0.623-0.109-0.935-0.163 c-0.569-0.099-1.137-0.198-1.71-0.301c-0.282-0.05-0.566-0.103-0.848-0.154c-0.61-0.111-1.22-0.221-1.834-0.335 c-0.204-0.038-0.41-0.078-0.615-0.116c-0.693-0.13-1.387-0.261-2.085-0.396c-0.067-0.013-0.134-0.026-0.201-0.04 c-3.486-0.676-7.017-1.411-10.551-2.211v95.258c26.185-0.279,46.166-22.355,55.154-38.943c3.915-7.229,7.307-26.002,8.315-47.11 C242.057,120.791,240.986,120.712,239.644,120.603z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarWoman);
export default __webpack_public_path__ + "static/media/avatar-woman.202e95697d4050fdc6e6521d41dee2bf.svg";
export { ForwardRef as ReactComponent };